/**
 * Shared look for the sign-in screens. First-time setup is used by
 * non-technical, often older clients: large type, one task per screen, and as
 * few words as possible.
 */
import { cn } from '../../utils.js';

export const inputCls =
  'mb-4 w-full rounded-md border border-transparent bg-white px-3 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 outline-none focus:border-ring';

export const bigInput =
  'mb-4 w-full rounded-lg border-2 border-transparent bg-white px-4 py-3.5 text-lg text-slate-900 placeholder:text-slate-400 outline-none focus:border-ring';

export const codeInput = `${bigInput} text-center font-mono tracking-[0.4em]`;

export const bigButton = 'w-full justify-center py-3.5 text-base';

const STEPS = ['סיסמה', 'אפליקציה'] as const;

/**
 * 1-2 progress, so it is always obvious how much is left.
 *
 * Centred with a fixed gap: spreading two steps across the full width left a
 * hole in the middle big enough to read as "something is missing here".
 */
export function Stepper({ current }: { current: 1 | 2 }) {
  return (
    <ol className="mb-6 flex items-center justify-center gap-10" aria-label={`שלב ${current} מתוך ${STEPS.length}`}>
      {STEPS.map((label, i) => {
        const n = (i + 1) as 1 | 2;
        const done = n < current;
        const active = n === current;
        return (
          <li key={label} className="flex w-20 flex-col items-center gap-1.5">
            <span
              aria-hidden
              className={cn(
                'flex h-9 w-9 items-center justify-center rounded-full text-base font-bold',
                active && 'bg-primary text-primary-foreground',
                done && 'bg-emerald-600 text-white',
                !active && !done && 'bg-white/15 text-white/50',
              )}
            >
              {done ? '✓' : n}
            </span>
            <span className={cn('text-xs', active ? 'font-semibold text-white' : 'text-white/50')}>{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
